var _effectorFileName = "/builds/gmini/front-common/src/Explorer/ctx/ctx.ts";
import { equals } from 'ramda';
import React, { useCallback, useContext, useMemo } from 'react';
export function createCtxProvider() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var Ctx = /*#__PURE__*/React.createContext(null);

  function useNodeCtxMenu(item, onOpenCategory) {
    var ctx = useContext(Ctx);
    var onClickOpen = useCallback(function (e) {
      e.stopPropagation();
      !ctx.hideCtxMenu && ctx.onOpen({
        x: e.clientX,
        y: e.clientY
      }, item, onOpenCategory);
    }, [ctx, item, onOpenCategory]);
    var onContextMenu = useCallback(function (e) {
      e.preventDefault();
      onClickOpen(e);
    }, [onClickOpen]);
    var onCloseMenu = useCallback(function () {
      ctx.onOpen(null, null);
    }, [ctx]);
    var open = equals(ctx.item, item);
    return useMemo(function () {
      return {
        onClickOpen: onClickOpen,
        onContextMenu: onContextMenu,
        open: open,
        onCloseMenu: onCloseMenu
      };
    }, [onClickOpen, onContextMenu, open, onCloseMenu]);
  }

  return {
    TreeContextMenuProvider: Ctx.Provider,
    useNodeCtxMenu: useNodeCtxMenu
  };
}